import { SearchSuggestionsPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchSuggestionsPopout/SearchSuggestionsPopout";

export { SearchSuggestionsPopout };
